"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildFooterTextId = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _ProgramInclusiveTech = _interopRequireDefault(require("../rules/ProgramInclusiveTech.js"));

var _context = require("../context");

var _layout = require("../layout");

var _messageBanner = require("../message-banner");

var _tooltip = require("../tooltip");

var _utils = require("../utils");

var _InputHeader = _interopRequireDefault(require("./InputHeader"));

var _inputFooter = require("./input-footer");

var _interfaces = require("./interfaces");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var buildFooterTextId = function buildFooterTextId(id) {
  return "".concat(id, "-footer");
};

exports.buildFooterTextId = buildFooterTextId;
var InputWrapperDefaultProps = {
  error: false,
  warning: false,
  required: false,
  shouldValidateNonInclusiveTerms: false,
  labelPosition: _interfaces.LabelPosition.Top
};

var InputWrapperBase = function InputWrapperBase(_ref) {
  var children = _ref.children,
      labelText = _ref.labelText,
      id = _ref.id,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? InputWrapperDefaultProps.error : _ref$error,
      _ref$warning = _ref.warning,
      warning = _ref$warning === void 0 ? InputWrapperDefaultProps.warning : _ref$warning,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? InputWrapperDefaultProps.required : _ref$required,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? InputWrapperDefaultProps.labelPosition : _ref$labelPosition,
      footer = _ref.footer,
      tooltipText = _ref.tooltipText,
      tooltipAlignment = _ref.tooltipAlignment,
      tooltipAltText = _ref.tooltipAltText,
      renderLabel = _ref.renderLabel,
      _ref$shouldValidateNo = _ref.shouldValidateNonInclusiveTerms,
      shouldValidateNonInclusiveTerms = _ref$shouldValidateNo === void 0 ? InputWrapperDefaultProps.shouldValidateNonInclusiveTerms : _ref$shouldValidateNo,
      propValue = _ref.value,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      dataTestId = _ref.dataTestId;

  var _useState = (0, _react.useState)(propValue || ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      nonInclusiveTermsMessage = _useState4[0],
      setNonInclusiveTermsMessage = _useState4[1];

  var labelId = (0, _utils2.buildLabelId)(id);
  var footerId = buildFooterTextId(id);
  var inputContainerProps = {
    flexDirection: labelPosition === _interfaces.LabelPosition.Leading ? 'row' : labelPosition === _interfaces.LabelPosition.Trailing ? 'row-reverse' : 'column',
    justifyContent: labelPosition === _interfaces.LabelPosition.Trailing ? 'flex-end' : undefined
  };
  var footerComponent = (0, _react.useMemo)(function () {
    switch ((0, _typeof2.default)(footer)) {
      case 'string':
        return (0, _core.jsx)(_inputFooter.InputFooter, {
          id: footerId,
          error: error,
          warning: warning
        }, footer);

      case 'function':
        return footer({
          id: footerId,
          inputId: id,
          error: error,
          warning: warning
        });

      default:
        return;
    }
  }, [footer, error, warning, footerId, id]);

  var validateNonInclusiveTerms = function validateNonInclusiveTerms() {
    if (typeof value !== 'string') {
      return;
    }

    var allUsedTerms = new Set();
    var alternativeTerms = new Set();

    _ProgramInclusiveTech.default.terms.forEach(function (rule) {
      var reg = rule.regex.javascript;
      var regex = new RegExp(reg, 'ig'); // 'ig' in RegExp, i: case insensitive, g: global

      var matches = value.match(regex);

      if (!!matches && matches.length > 0) {
        matches.forEach(function (match) {
          return allUsedTerms.add(match);
        });
        rule.alternative_terms.forEach(function (alternative) {
          return alternativeTerms.add(alternative);
        });
      }
    });

    if (allUsedTerms.size > 0) {
      var w1 = allUsedTerms.size > 1 ? 'terms were' : 'term was';
      var w2 = allUsedTerms.size > 1 ? 'these terms' : 'this term';
      var usedTerms = (0, _toConsumableArray2.default)(allUsedTerms).join(', ');
      var alternatives = (0, _toConsumableArray2.default)(alternativeTerms).join(', ');
      var message = "The following non-inclusive ".concat(w1, " used: ").concat(usedTerms, ".\n\nReplace ").concat(w2, " with more inclusive alternatives like ").concat(alternatives, ".");
      setNonInclusiveTermsMessage(message);
    } else {
      setNonInclusiveTermsMessage('');
    }
  };

  var propsForValidation = shouldValidateNonInclusiveTerms ? {
    value: value,
    onChange: function onChange(e) {
      setValue(e.target.value);
      _onChange && _onChange(e);
    },
    onBlur: function onBlur(e) {
      validateNonInclusiveTerms();
      _onBlur && _onBlur(e);
    }
  } : {};
  return (0, _core.jsx)(_context.StencilConsumer, null, function (context) {
    return (0, _core.jsx)(_layout.Col, (0, _utils.buildDataTestProps)({
      dataTestComponent: 'StencilReactInputWrapper',
      dataTestId: dataTestId
    }), (0, _core.jsx)(_layout.Flex, (0, _extends2.default)({
      gridGap: (0, _utils.getThemeSpace)(context, _utils.LABEL_SPACING)
    }, inputContainerProps), (0, _core.jsx)(_InputHeader.default, {
      htmlFor: id,
      labelId: labelId,
      labelText: labelText,
      error: error,
      warning: warning,
      required: required,
      tooltipText: tooltipText,
      tooltipAlignment: tooltipAlignment,
      tooltipAltText: tooltipAltText,
      renderLabel: renderLabel,
      dataTestId: dataTestId
    }), children(_objectSpread({
      error: error,
      warning: warning,
      id: id,
      'aria-required': required,
      'aria-invalid': error,
      'aria-describedby': !!footer ? footerId : undefined
    }, propsForValidation))), footerComponent, shouldValidateNonInclusiveTerms && !!nonInclusiveTermsMessage && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
      height: (0, _utils.getThemeSpace)(context, _utils.LABEL_SPACING)
    }), (0, _core.jsx)(_messageBanner.MessageBanner, {
      type: _messageBanner.MessageBannerType.Bias
    }, nonInclusiveTermsMessage)));
  });
};

InputWrapperBase.defaultProps = InputWrapperDefaultProps;
var InputWrapper = (0, _stencilReactDesc.describe)(InputWrapperBase).description('Wrapper for for elements providing a header and footer.');
InputWrapper.propTypes = _objectSpread(_objectSpread({}, (0, _utils.omit)(_InputHeader.default.describedPropTypes, ['htmlFor'])), {}, {
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Function as child responsible for rendering the form element, which receives pre-customized input props.').format("({\n  error: boolean,\n  warning: boolean,\n  id: string,\n  'aria-required': boolean,\n  'aria-describedby': string,\n  'aria-invalid': boolean\n}) => node"),
  id: _stencilReactDesc.PropTypes.string.isRequired.description('The id of form element, which will be propagated to the children function.'),
  labelPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.LabelPosition)).description('Sets the position of the label around the input element.'),
  warning: _stencilReactDesc.PropTypes.bool.description('Whether the element is in warning state.'),
  footer: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.func]).description('Specifies the footer to be displayed.'),
  shouldValidateNonInclusiveTerms: _stencilReactDesc.PropTypes.bool.description('Whether the element should perform non-inclusive terms validation. Should be used only with TextArea and Input components.'),
  value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.string)]).description('Used to control the value in TextArea and Input components when shouldValidateNonInclusiveTerms is used.'),
  onBlur: _stencilReactDesc.PropTypes.func.description('Used to control the onBlur event in TextArea and Input components when shouldValidateNonInclusiveTerms is used.'),
  onChange: _stencilReactDesc.PropTypes.func.description('Used to control the onChange event in TextArea and Input components when shouldValidateNonInclusiveTerms is used.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes; which will also be propagated to the internal InputHeader."),
  tooltipAlignment: _stencilReactDesc.PropTypes.oneOf(Object.values(_tooltip.TooltipAlignment)).description('Sets the tooltip alignment.')
});
InputWrapper.displayName = 'InputWrapper';
var _default = InputWrapper;
exports.default = _default;